var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacosIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 74,
    viewBox: "0 0 116 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 65H1C1 65 1 73 10.5 73H106C115 73 115 65 115 65Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C11 3.68629 13.6863 1 17 1H99C102.314 1 105 3.68629 105 7V65H11V7Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3613 28.5234C67.2188 28.6359 64.7031 30.0785 64.7031 33.2863C64.7031 36.9967 67.9042 38.3093 68 38.3418C67.9853 38.4218 67.4915 40.1395 66.3122 41.8897C65.2608 43.4298 64.1626 44.9675 62.4921 44.9675C60.8215 44.9675 60.3916 43.9799 58.4631 43.9799C56.5837 43.9799 55.9155 45 54.3874 45C52.8594 45 51.7931 43.5749 50.5673 41.8247C49.1473 39.7695 48 36.5767 48 33.5464C48 28.6859 51.1053 26.1081 54.1614 26.1081C55.7853 26.1081 57.1389 27.1932 58.1585 27.1932C59.1289 27.1932 60.6422 26.0431 62.4896 26.0431C63.1898 26.0431 65.7054 26.1081 67.3613 28.5234ZM61.6126 23.9854C62.3766 23.0628 62.9171 21.7827 62.9171 20.5026C62.9171 20.325 62.9023 20.145 62.8704 20C61.6273 20.0475 60.1484 20.8426 59.2566 21.8952C58.5564 22.7053 57.903 23.9854 57.903 25.283C57.903 25.478 57.9349 25.6731 57.9496 25.7356C58.0283 25.7506 58.156 25.7681 58.2837 25.7681C59.3991 25.7681 60.8019 25.008 61.6126 23.9854Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacosIcon);
export default __webpack_public_path__ + "static/media/macos-icon.e5a533efa933276da87019d879179fc2.svg";
export { ForwardRef as ReactComponent };